import type { CSSProperties, HTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../utils/class-names';

import styles from './spinner.module.css';

export type SpinnerProps = {
  size?: number | string;
} & HTMLAttributes<HTMLElement>;

/**
 * @param {number | string} [size] The size of the spinner. If it's passed as a number, it will be converted into pixels.
 * @default 24
 */
export function Spinner({ size = 24, className, style, ...props }: SpinnerProps) {
  const spinnerStyles = {
    ...style,
    '--size': typeof size === 'string' ? size : `${size}px`,
  } as CSSProperties;

  return (
    <div
      role="img"
      data-testid="spinner"
      className={classNames(styles.spinner, className)}
      style={spinnerStyles}
      {...props}
    >
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
